/**
 * Temporary access gate for GCA entities.
 *
 * Non-PSU GCA entities stay on the home page but have the eco-restoration
 * selection buttons disabled until the unlock moment below. PSU entities
 * (gca_type === "TYPE_2") and all non-GCA users (e.g. implementing agencies,
 * approvers) are never affected.
 *
 * The gate is time-based and lifts automatically once the deadline passes —
 * no code change needed after Monday. Remove this file and its callers once
 * the lock is no longer required.
 */

// PSU profiles are stored as gca_type === "TYPE_2" in gca_profile.
export const PSU_GCA_TYPE = "TYPE_2";

// Mon 2026-06-08, 10:00 IST (+05:30). After this instant the lock lifts.
export const ACCESS_UNLOCK_AT = new Date("2026-06-08T10:00:00+05:30");

// Human-readable unlock time in IST, e.g. "Monday, 8 June 2026 at 10:00 AM".
export const ACCESS_UNLOCK_LABEL = ACCESS_UNLOCK_AT.toLocaleString("en-IN", {
  weekday: "long",
  day: "numeric",
  month: "long",
  year: "numeric",
  hour: "numeric",
  minute: "2-digit",
  hour12: true,
  timeZone: "Asia/Kolkata",
});

type AccessLockInput = {
  isGCAEntity?: boolean;
  gcaType?: string;
};

/**
 * True when the user's selection actions should be locked.
 * Only GCA entities that are not PSU, and only before the unlock time.
 */
export const isAccessLocked = ({
  isGCAEntity,
  gcaType,
}: AccessLockInput): boolean => {
  if (!isGCAEntity) return false; // only GCA entities are gated
  if (gcaType === "TYPE_2" || gcaType === "PSU") return false; // PSU entities always allowed
  return Date.now() < ACCESS_UNLOCK_AT.getTime();
};
